import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreState } from "@obg/ngx.core";
import { RouteSelector } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

@Component({
	selector: "obg-m-core-slim-layout-container",
	templateUrl: "./core-slim-layout.container.html",
	styleUrls: ["./core-slim-layout.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CoreSlimLayoutContainer implements OnInit {
	@HostBinding("class.obg-m-core-slim-layout") hostCssClass = true;

	title$: Observable<string> | undefined;

	constructor(private store: Store<CoreState>) {}

	ngOnInit() {
		this.title$ = this.store.select<{ title: string } | undefined>(RouteSelector.getData).pipe(
			filter((data) => !!data?.title),
			map((t) => t!.title)
		);
	}
}
